<template>
  <div class="animated-background">
    <!-- <div style="display: flex; justify-content:right; margin-top: 5%;">
      <q-btn
        style="width: 300px;height: 50px;border-radius: 30px 0px 0px 30px; background-color: #2166B1; color:white; font-size: larger;font-weight: bold;"
        @click="mainelement"><q-spinner-hourglass color="white" />Click Here</q-btn>
    </div> -->
    <q-blur v-if="showcontainer" :intensity="10">
      <q-dialog v-model="showcontainer" persistent :maximized="$q.screen.lt.sm">
        <q-card class="signupPage" style="display: flex; justify-content: center; ">
          <q-card-section>
            <div class="wrapper" v-if="!$store.state.signedIn" style="margin-top: 0%;">
              <div>
                <div class="right" style="border:none;">
                  <vs-tabs alignment="fixed">
                    <vs-tab label="Login/Signup" style="color: black !important;" @click="change_image('login')"
                      color="black">


                      <div>
                        <div>
                          <form method="post" id="contactForm" ref="contactForm" name="contactForm"
                            action="https://script.google.com/macros/s/AKfycbz77ip8fV7MuN3J7q25WRiVD3cDRzrNx2u6DXjudw7i64AP4j_iQKJ04zayZHN11J8h3g/exec"
                            @submit.prevent="handleSubmit">
                            <!-- <div
                              style=" display: flex; justify-content: center; font-size: large; font-weight:bold; color: rgb(155,155,155)">
                              <p>Login/SignUp</p>
                            </div> -->

                            <!-- Modern Signup Container -->
                            <div style="max-width: 480px; margin: 0 auto; padding: 40px 24px;">

                              <!-- Header Section -->
                              <div style="text-align: center; margin-bottom: 40px;">
                                <h1 style="font-size: 32px; font-weight: 700; color: #1a1a1a; margin: 0 0 12px 0; line-height: 1.2;">
                                  Start Your Free Trial
                                </h1>
                                <p style="font-size: 17px; color: #6b7280; margin: 0; line-height: 1.5;">
                                  Automate pricing, track campaigns, and grow your Amazon business
                                </p>
                              </div>

                              <!-- Form Section -->
                              <div style="margin-bottom: 24px;">
                                <div class="input-field" style="width: 100%; position: relative;">
                                  <input type="text" id="email1" name="Email"
                                    placeholder="Enter your work email"
                                    v-model="details['email']" required
                                    style="width: 100%; height: 52px; padding: 0 48px 0 16px; font-size: 16px; border: 1.5px solid #d1d5db; border-radius: 8px; background-color: #ffffff; transition: all 0.2s; box-sizing: border-box;"
                                    @keyup.enter="sign_up"
                                    @focus="$event.target.style.borderColor='#378CEF'; $event.target.style.boxShadow='0 0 0 3px rgba(55, 140, 239, 0.1)'"
                                    @blur="$event.target.style.borderColor='#d1d5db'; $event.target.style.boxShadow='none'" />

                                  <!-- Icon on the right -->
                                  <font-awesome-icon v-if="is_email1_valid"
                                    icon="fa-solid fa-circle-check"
                                    style="position: absolute; right: 16px; top: 50%; transform: translateY(-50%); color: #10b981; font-size: 20px;" />
                                  <font-awesome-icon v-if="is_email1_error"
                                    icon="fa-solid fa-exclamation-circle"
                                    style="position: absolute; right: 16px; top: 50%; transform: translateY(-50%); color: #ef4444; font-size: 20px;" />

                                  <label class="label-2" v-html="error_email1" ref="label-email1" for="email1"
                                    style="display: block; margin-top: 8px; font-size: 14px; color: #ef4444;"></label>
                                </div>
                              </div>

                              <!-- CTA Button -->
                              <q-btn
                                class="analysisbtn"
                                style="width: 100%; height: 52px; background: linear-gradient(135deg, #378CEF 0%, #2563eb 100%); color: white; font-size: 16px; font-weight: 600; border-radius: 8px; text-transform: none; box-shadow: 0 4px 12px rgba(55, 140, 239, 0.3); transition: all 0.2s;"
                                @click="sign_up()"
                                :disabled="!is_email1_valid"
                                @mouseenter="$event.target.style.transform='translateY(-1px)'; $event.target.style.boxShadow='0 6px 16px rgba(55, 140, 239, 0.4)'"
                                @mouseleave="$event.target.style.transform='translateY(0)'; $event.target.style.boxShadow='0 4px 12px rgba(55, 140, 239, 0.3)'">
                                <span style="font-size: 16px;">Start Free Trial</span>
                                <span style="margin-left: 8px; font-size: 18px;">→</span>
                              </q-btn>

                              <!-- Trust Indicators -->
                              <div style="display: flex; justify-content: center; gap: 24px; margin-top: 24px; flex-wrap: wrap;">
                                <div style="display: flex; align-items: center; gap: 6px;">
                                  <span style="color: #10b981; font-size: 16px; font-weight: 600;">✓</span>
                                  <span style="font-size: 14px; color: #6b7280;">No credit card</span>
                                </div>
                                <div style="display: flex; align-items: center; gap: 6px;">
                                  <span style="color: #10b981; font-size: 16px; font-weight: 600;">✓</span>
                                  <span style="font-size: 14px; color: #6b7280;">14-day trial</span>
                                </div>
                                <div style="display: flex; align-items: center; gap: 6px;">
                                  <span style="color: #10b981; font-size: 16px; font-weight: 600;">✓</span>
                                  <span style="font-size: 14px; color: #6b7280;">2-min setup</span>
                                </div>
                              </div>

                              <!-- Social Proof -->
                              <div style="text-align: center; margin-top: 32px; padding-top: 24px; border-top: 1px solid #e5e7eb;">
                                <p style="font-size: 14px; color: #9ca3af; margin: 0;">
                                  Trusted by <strong style="color: #6b7280;">500+</strong> Amazon sellers across India
                                </p>
                              </div>

                            </div>
                          </form>
                          <div v-if="signup_error" class="signupError">{{ signup_error }}</div>
                        </div>
                        <div>
                          <q-dialog v-model="showblockedprofile">
                            <q-card class="blockedprofile">
                              <q-card-section>
                                <div style="display: flex;" @click="backblockeduser">
                                  <q-icon name="arrow_back" size="sm" />
                                  <p>Back</p>
                                </div>
                                <div>
                                  <div style="display: flex; justify-content: center;">
                                    <img src="../assets/blockeduser.jpg" width="450px" height="300px" />
                                  </div>
                                  <div>
                                    <!-- <div style="display: flex; justify-content: center;">
                                  <q-icon name="error_outline" size="md" style="color:red"/>
                                  </div> -->
                                    <div style="display: flex; justify-content: center; margin-top: 3%;">
                                      <p style="font-size: larger;font-weight: bold;color:red;">Your Account is blocked
                                        <br>Please contact Admin!!
                                      </p>
                                    </div>
                                  </div>
                                </div>

                              </q-card-section>
                            </q-card>


                          </q-dialog>
                        </div>

                        <div>
                          <q-dialog v-model="showEditotp" persistent :maximized="$q.screen.lt.sm">
                            <q-card class="verificationForm">
                              <q-card-section>
                                <div class="closing-element">
                                  <p style="font-size: large; cursor: pointer;color: #378CEF;" @click="cancel">Back</p>
                                  <q-icon name="close" class="qicon" @click="cancel" />
                                </div>

                                <div class="sub-container-otp">

                                  <div>
                                    <div class="element1">
                                      <div class="icon-p">
                                        <img src="../assets/tick.jpg" width="70px" height="70px">
                                        <p>uniQin.ai Account created <br>Please
                                          verify</p>
                                      </div>
                                      <div class="verify-p">
                                        <p>Use the verification OTP mailed to <strong>{{ UserEmail }}</strong> to get
                                          started.

                                        </p>
                                      </div>
                                    </div>
                                    <!-- <p style="font-weight: bold; color: grey;text-align: left;">Enter OTP</p> -->
                                    <p class="enterotp">Enter
                                      the OTP</p>
                                    <div class="otp-card-inputs">


                                      <input ref="otpInput" maxlength="6" type="tel" class="otp-box"
                                        placeholder="Enter Your OTP Here" @input="handleOtpInput" v-model="otp">
                                      <div class="error-message" v-if="errorMessage">
                                        {{ errorMessage }}
                                      </div>
                                      <q-btn class="verify" style=" border-radius: 0px;" @click="verify"
                                        :disabled="isdisableverify">Verify</q-btn>

                                    </div>

                                    <div v-if="successMessage">{{ successMessage }}</div>



                                    <div class="timer">
                                      <div v-if="resendTimer > 0">
                                        <p>Resend OTP in {{ resendTimer }} seconds</p>
                                      </div>
                                      <div v-else class="resendotp-p">
                                        <p>Didn't Receive Code ? </p>
                                        <a href="#" style="text-align: center; text-decoration-line: none;"
                                          @click="resendcode" :disabled="resendTimer > 0">
                                          Resend OTP
                                        </a>
                                      </div>
                                    </div>





                                  </div>
                                </div>

                              </q-card-section>
                            </q-card>
                          </q-dialog>
                        </div>
                        <div>
                          <q-dialog v-model="showuserprofile" :class="{ 'bg-white': true }" persistent
                            :maximized="$q.screen.lt.sm">
                            <q-card class="setpassword">
                              <q-card-section>
                                <div style="display: flex; justify-content: space-between;">
                                  <p style="font-size: medium; cursor: pointer; color:#378CEF" @click="back">Back</p>
                                  <q-icon name="close"
                                    style="font-size: x-large; cursor: pointer;padding: 2px; border-radius:20px;background-color: #E5E5E5;"
                                    @click="close" />
                                </div>
                                <div class="account-details">

                                  <div class="headingh1">
                                    <h6>Set New Password</h6>
                                    <p>Enter the password for <Strong>{{ UserEmail }}</Strong> to login to your account
                                    </p>
                                  </div>

                                  <div>
                                    <div class="input-group">
                                      <input type="password" id="password" class="form-control"
                                        placeholder="Enter a New Password" v-model="userpassword"
                                        :type="passwordVisible ? 'text' : 'password'"
                                        style="height: 40px;padding:0px;background-color: white;border:2px solid #A9C8EB; border-right:none; border-bottom: 2px solid #A9C8EB !important;"
                                        autocomplete="new-password" v-html="set_password" />
                                      <button @click="togglePasswordVisibility"
                                        style="height:40px; width:30px;border:2px solid #A9C8EB; border-left:none;padding-right:15px;background-color: white;">
                                        <i :class="['fas', passwordVisible ? 'fa-eye' : 'fa-eye-slash']"></i>
                                      </button>


                                    </div>
                                    <div>
                                      <p v-if="is_setpassword_error" style="color: red;">✗ Passwords should ideally
                                        include at least one uppercase letter, one lowercase letter, one digit,
                                        and one of the following special characters: #, @, &, $, !, *. The length must be
                                        between 8 to 16 characters.</p>
                                      <p v-if="is_setpassword_valid" class="text-positive">✓ Password
                                        is valid</p>
                                    </div>
                                  </div>
                                  <div class="input-group">
                                    <input type="password" id="password" class="form-control"
                                      placeholder="Re-enter the Password to confirm" v-model="userconfirmpassword"
                                      :type="confirmpasswordVisible ? 'text' : 'password'"
                                      style="height: 40px;padding:0px;background-color: white;border:2px solid #A9C8EB; border-right:none; border-bottom: 2px solid #A9C8EB !important;"
                                      autocomplete="new-password" v-html="error_setconfirm_password" />
                                    <button @click="toggleconfirmPasswordVisibility"
                                      style="height:40px; width:30px;border:2px solid #A9C8EB; border-left:none;padding-right:15px;background-color: white;">
                                      <i :class="['fas', confirmpasswordVisible ? 'fa-eye' : 'fa-eye-slash']"></i>
                                    </button>

                                  </div>
                                  <div>
                                    <p v-if="is_setconfirm_password_error" class="text-negative">
                                      ✗ Password not matching</p>
                                    <p v-if="is_setconfirm_password_valid" class="text-positive">
                                      ✓ Password is confirmed</p>
                                  </div>
                                  <div v-if="passwordError" class="error">
                                    {{ passwordError }}
                                  </div>


                                </div>
                                <div>
                                  <div style="display: flex; justify-content: center;">
                                    <q-btn class="confirm-button" @click="storePassword"
                                      :disabled="!isdisablesetpassword">Confirm</q-btn>
                                  </div>
                                  <!-- <div style="text-align: center; color: green;margin-top: 20px;" v-if="notifyMessage">{{ notifyMessage }}</div> -->

                                </div>
                              </q-card-section>
                            </q-card>
                          </q-dialog>
                        </div>
                        <div>
                          <q-dialog v-model="showsuccessmsg">
                            <q-card
                              style="background-color: white!important; width: 500px; height: 500px; overflow: hidden;">
                              <q-card-section>
                                <div style="display:block; justify-content:center;margin-top:10%;">
                                  <div style="font-size:larger;text-align:center">
                                    <h4>SUCCESS!</h4>
                                  </div>
                                  <div style="text-align:center">
                                    <p>Your Account has been verified!. Enjoy!!</p>
                                  </div>
                                  <div style="display: flex; justify-content:center;">
                                    <!-- <span style="border:2px solid green; width:50px; border-radius:0px; background-color:green">
                                          <q-icon name="check" size="50px" color="white" />
                                          </span> -->
                                    <img src="../assets/emoji.jpg" />
                                  </div>
                                  <div style="display:flex; justify-content: center; margin:10%;">
                                    <q-btn style="background-color:#2166B1; color:white; width:30%;"
                                      @click="otp_login">Login</q-btn>
                                  </div>
                                </div>

                              </q-card-section>
                            </q-card>
                          </q-dialog>
                        </div>
                        <div>
                          <q-dialog v-model="showorganizationform">
                            <q-card
                              style="background-color: white!important; width: auto; height: auto; overflow: hidden;">
                              <q-card-section>

                                <q-form @submit="submitform">

                                  <div class="input-organization">
                                    <div>
                                      <div styel="display: flex; justify-content:center;" class="q-mb-md">
                                        <h6>Let's go! You're almost there...</h6>
                                      </div>
                                      <div class="q-mb-md">
                                        <q-input v-model="organizationName" label="Organization Name" type="text" />
                                      </div>
                                      <div class="q-mb-md">
                                        <q-select v-model="Typeofbusiness" label="Type Of Business"
                                          :options="dropdownOptions" outlined />
                                      </div>
                                      <div class="q-mb-md">
                                        <q-input v-model="monthlyadsales" label="Monthly AD Sales" type="text" />
                                      </div>
                                      <div class="q-mb-md">
                                        <q-input v-model="monthlyadcost" label="Monthly AD Cost" type="text" />
                                      </div>


                                      <div class="q-mb-md"><q-select v-model="operatingcountry" label="Operating Country"
                                          :options="dropdownOptions" outlined />
                                      </div>
                                      <div class="q-mb-lg">
                                        <q-select v-model="preferredtimezone" label="Preferred Time Zone"
                                          :options="dropdownOptions" outlined />
                                      </div>


                                      <div class="q-mb-md">
                                        <center>
                                          <q-btn label="Proceed" type="submit" color="primary" @click="proceed" />
                                        </center>
                                      </div>
                                    </div>

                                  </div>
                                </q-form>
                                <!-- <q-card-media style="margin-left: 5%; ">
          <img src="../assets/login_img.webp" alt=""  style="width: 90%; height: 90%; object-fit:contain; margin-right: 0; padding-right: 0;" >
        </q-card-media> -->

                              </q-card-section>
                            </q-card>
                          </q-dialog>
                        </div>
                        <div>
                          <q-dialog v-model="connectingaccount">
                            <q-card style="color: white !important; width: 500px; height: 500px; ">
                              <q-card-section>
                                <div>
                                  <div>

                                  </div>
                                </div>


                              </q-card-section>
                            </q-card>
                          </q-dialog>
                        </div>
                        <div>
                          <q-dialog v-model="showpassword" persistent :maximized="$q.screen.lt.sm">
                            <q-card class="passwordpage">
                              <q-card-section>


                                <div class="sub-container">

                                  <div class="content">
                                    <div class="back">
                                      <p style="color:#378CEF; font-size: large;cursor: pointer;" @click="goback">Back</p>
                                      <q-icon name="close" style="font-size: xx-large; cursor: pointer;"
                                        @click="goback" />
                                    </div>
                                    <h6>Enter Password</h6>
                                    <p>Enter the password for <strong>{{ UserEmail }}</strong> to login to your
                                      account.</p>
                                    <div class="login-form">
                                      <div class="password-container">
                                        <label for="password">Password</label>
                                        <q-link @click="popup" style="cursor: pointer;color: red">Reset Password</q-link>
                                      </div>
                                      <div>
                                        <q-dialog v-model="showEdit" :class="{ 'bg-white': true }" persistent
                                          :maximized="$q.screen.lt.sm">
                                          <q-card class="reset_popup">
                                            <q-card-section>
                                              <div style="display: flex; justify-content: space-between;">
                                                <q-icon name="arrow_back" size="sm" @click="back_resetpassword" />
                                                <q-icon name="close" size="sm" @click="back_resetpassword" />
                                              </div>
                                              <div class="forgot-password q-py-xl q-px-lg">
                                                <h4 class="q-mb-lg">Reset your password?</h4>
                                                <p class="q-my-lg">Enter your Email below and we will send a CODE to reset
                                                  your password</p>
                                                <input type="email" class="email q-my-sm" v-model="this.details.email"
                                                  placeholder="Enter your Email">
                                                <input type="submit" class="submit q-my-sm"
                                                  @click="send_confirmation_code()" value="Continue">

                                              </div>

                                            </q-card-section>

                                          </q-card>
                                        </q-dialog>
                                      </div>
                                      <div>
                                        <q-dialog v-model="showresetpassword" persistent :maximized="$q.screen.lt.sm">
                                          <q-card class="showresetpassword">
                                            <q-card-section>
                                              <div style="display:flex;justify-content: end;">
                                                <q-icon name="close" size="sm" @click="closecall"></q-icon>
                                              </div>
                                              <div class="enter-password q-px-lg">

                                                <p class="q-my-lg">We have sent a password reset code to the email id you
                                                  entered. Enter it below to reset your password.</p>
                                                <div class="reset-code">
                                                  <input type="text" v-html="error_code" v-model="code"
                                                    placeholder="Enter Your Code" maxlength="6">

                                                  <p v-if="is_code_error" class="text-negative">✗ Please enter a valid
                                                    reset
                                                    code</p>
                                                  <p v-if="is_code_valid" class="text-positive">✓ Reset code is valid</p>
                                                </div>

                                                <div style="display: flex;margin-top: 1rem;">
                                                  <input style="width:100%" type="password" v-html="error_password"
                                                    v-model="password" :type="passwordVisible ? 'text' : 'password'"
                                                    placeholder="Enter a Password" autocomplete="new-password">
                                                  <button @click="togglePasswordVisibility"
                                                    style="height: 35px; padding: 0px 10px 0px 10px ;margin-right: 0px;border: 1px solid #DDE0E2;border-left: none;">
                                                    <i :class="['fas', passwordVisible ? 'fa-eye' : 'fa-eye-slash']"></i>
                                                  </button>
                                                </div>


                                                <p v-if="is_password_error" class="text-negative"
                                                  style="text-align: justify;">✗ Passwords should ideally include at least
                                                  one uppercase letter, one lowercase letter, one digit, and
                                                  one of the following special characters: #, @, &, $, !, *. The length
                                                  must be between 8 to 16 characters.</p>
                                                <p v-if="is_password_valid" class="text-positive">✓ Password is valid</p>
                                                <div class="visibility">
                                                  <input type="password" v-html="error_confirm_password"
                                                    v-model="confirm_password" placeholder="Enter a Confirm Password"
                                                    :type="confirmpasswordVisible ? 'text' : 'password'"
                                                    autocomplete="new-password">
                                                  <button @click="toggleconfirmPasswordVisibility"
                                                    style="height: 35px;padding: 0px 10px 0px 10px ;margin-right: 0px;border: 1px solid #DDE0E2;border-left: none;">
                                                    <i
                                                      :class="['fas', confirmpasswordVisible ? 'fa-eye' : 'fa-eye-slash']"></i>
                                                  </button>
                                                </div>

                                                <p v-if="is_confirm_password_error" class="text-negative">✗ Password not
                                                  matching</p>
                                                <p v-if="is_confirm_password_valid" class="text-positive">✓ Password is
                                                  confirmed</p>

                                                <p v-if="reset_error_msg" style="color:red;text-align: center;">{{
                                                  reset_error_msg }}</p>


                                                <button class="submit q-my-sm"
                                                  style="margin-top:1rem; width:100%;height:40px;font-weight:bold;border-radius:5px;"
                                                  @click="reset_password()" :disabled="!isFormValid">RESET</button>

                                              </div>

                                            </q-card-section>
                                          </q-card>
                                        </q-dialog>
                                      </div>
                                      <div>

                                        <div class="passwordfield" style="display: flex;">
                                          <input type="password" v-model="manual.password" placeholder="Enter a password"
                                            auto-complete="new-password" :type="visible ? 'text' : 'password'"
                                            class="inp_password" />
                                          <button @click="ExistpasswordVisible"
                                            style="height:40px; width:30px;padding-left:5px;border:none;padding-right:15px;background-color: white;">
                                            <i :class="['fas', visible ? 'fa-eye' : 'fa-eye-slash']"></i>
                                          </button>


                                        </div>
                                        <div class="passwordbtn">
                                          <button @click="manual_login()">LOGIN</button>
                                        </div>

                                      </div>
                                    </div>
                                    <!-- <div style="display: flex; justify-content: start;">

                                    <div style="display: flex; margin-top: 3%;">
                                      <q-link @click="loginviaotp" class="text-red" style="cursor: pointer;">Login via
                                        OTP</q-link>
                                    </div> -->
                                    <!-- <div style="margin-top: 20px;">
                                <q-btn class="q-btn-login" @click="manual_login">Login</q-btn>
                              </div> -->
                                    <!-- </div> -->

                                    <!-- <div>
                                    <q-dialog v-model="showEditotp">
                                      <q-card
                                        style="background-color:white!important; width:500px; height:500px; overflow: hidden;"
                                        @click.capture="">
                                        <q-card-section>
                                          <div style="display: flex; justify-content: end;">
                                            <q-icon name="close" style="font-size: xx-large; cursor: pointer;" @click="cancel" />
                                          </div>

                                          <div class="sub-container-otp">

                                            <div>
                                              <h6>Verification Code</h6>
                                              <p>Please enter the verification code sent <br /> to <strong>{{ UserEmail
                                              }}</strong>
                                              </p>
                                              <div>
                                                <p>Enter OTP</p>
                                              </div>
                                              <div class="otp-card-inputs">

                                                <input ref="otpInput" maxlength="6" type="tel" class="otp-box"
                                                  placeholder="Enter Your OTP Here" @input="handleOtpInput" v-model="otp"
                                                  style="margin-left:0px; margin-top:0px;">
                                              </div>


                                              <div class="resend-code">
                                                <p>Didn't receive an OTP?</p>
                                                <div v-if="resendTimer > 0">
                                                  <p>Resend OTP in {{ resendTimer }} seconds</p>
                                                </div>
                                                <div v-else>
                                                  <a href="#" style="text-align: center; text-decoration-line: underline;"
                                                    @click="resendcode" :disabled="resendTimer > 0">
                                                    Resend OTP?
                                                  </a>
                                                </div>
                                              </div>



                                            </div>
                                          </div>

                                        </q-card-section>
                                      </q-card>
                                    </q-dialog>
                                  </div> -->

                                  </div>
                                </div>


                              </q-card-section>
                            </q-card>
                          </q-dialog>
                        </div>

                        <!-- <div class="forgot-password q-mx-lg">
                                <router-link to="/forgotPassword"><span class="q-ml-sm">Forgot your password?</span></router-link>
                              </div> -->
                        <div class="space q-my-lg" style="margin-top: 10%">
                          <p class="textcenter latoBold font12 greyText appendBottom15" style="color:rgb(159, 117, 117)">
                            OR USE YOUR GMAIL ACCOUNT</p>
                        </div>
                        <div class="google-login">
                          <img src="../assets/google_pic.png" @click="login()" width="45" height="45" />
                        </div>
                        <!-- <div class="forgot-password q-mx-lg" style="margin-top: 2%;">
                                <router-link to="/forgotPassword"><span class="q-ml-sm">Forgot your password?</span></router-link>
                              </div> -->
                        <!-- <div style="margin-top:10%">
                                <hr>
                              </div> -->

                        <div class="bottom-space">
                          <p>
                            By proceeding, you agree to uniqin.ai
                            <a href="https://uniqin.ai/terms" target="_blank"
                              @click="trackTermsLink">Terms and Conditions</a>
                          </p>
                        </div>
                        <!-- <button @click="login()">login</button>
                          <p>is login? {{is_login}}</p> -->
                      </div>
                    </vs-tab>
                    <!-- <vs-tab label="Request Access" @click="change_image('request_access')">
                            <div>
                              <form method="post" id="contactForm" ref="contactForm" name="contactForm"
                                action="https://script.google.com/macros/s/AKfycbz77ip8fV7MuN3J7q25WRiVD3cDRzrNx2u6DXjudw7i64AP4j_iQKJ04zayZHN11J8h3g/exec"> -->
                    <!-- <div class="input-field">
                                  <input type="text" id="name" name="Name" v-model="details['name']" required />
                                  <font-awesome-icon icon="fa-solid fa-user" class="icons" />
                                  <label class="label-1" for="name">Name</label>
                                  <label class="label-2" v-html="error_name" ref="label-name" for="name"></label>
                                  <label for="name" class="label-3"><font-awesome-icon v-if="is_name_valid"
                                      icon="fa-solid fa-circle-check" style="color: green" class="valid-icons" /></label>
                                  <label for="name" class="label-3"><font-awesome-icon v-if="is_name_error"
                                      icon="fa-solid fa-exclamation-circle" style="color: red" class="valid-icons" /></label>
                                </div> -->
                    <!-- <div class="input-field">
                                  <input type="text" id="email1" name="Email" v-model="details['email']" required />
                                  <font-awesome-icon icon="fa-solid fa-envelope" class="icons" />
                                  <label class="label-1" for="email1">Email</label>
                                  <label class="label-2" v-html="error_email1" ref="label-email1" for="email1"></label>
                                  <label for="email1" class="label-3"><font-awesome-icon v-if="is_email1_valid"
                                      icon="fa-solid fa-circle-check" style="color: green" class="valid-icons" /></label>
                                  <label for="email1" class="label-3"><font-awesome-icon v-if="is_email1_error"
                                      icon="fa-solid fa-exclamation-circle" style="color: red" class="valid-icons" /></label>
                                </div> -->
                    <!-- <div class="input-field">
                                  <input type="text" id="company" name="Company" v-model="details['company']" style="z-index: 10000"
                                    required />
                                  <font-awesome-icon icon="fa-solid fa-building" class="icons" />
                                  <label class="label-1" for="company">Company</label>
                                  <label class="label-2" v-html="error_company" ref="label-company" for="company"></label>
                                  <label for="company" class="label-3"><font-awesome-icon v-if="is_company_valid"
                                      icon="fa-solid fa-circle-check" style="color: green" class="valid-icons" /></label>
                                  <label for="company" class="label-3"><font-awesome-icon v-if="is_company_error"
                                      icon="fa-solid fa-exclamation-circle" style="color: red" class="valid-icons" /></label>
                                </div> -->
                    <!-- <div class="input-field">
                                  <input type="password" id="password1" name="Password1" v-model="details['password1']" required />
                                  <font-awesome-icon icon="fa-solid fa-lock" class="icons" />
                                  <label class="label-1" for="password1">Password</label>
                                  <label class="label-2" v-html="error_password1" ref="label-mobile" for="password1"></label>
                                  <label for="password1" class="label-3"><font-awesome-icon v-if="is_password1_valid"
                                      icon="fa-solid fa-circle-check" style="color: green" class="valid-icons" /></label>
                                  <label for="password1" class="label-3"><font-awesome-icon v-if="is_password1_error"
                                      icon="fa-solid fa-exclamation-circle" style="color: red" class="valid-icons" /></label>
                                </div>
                                <div class="password-caption q-mx-lg text-caption">
                                  <p>
                                    * Password should be 6 to 15 characters which contain at
                                    least one numeric digit and a special character
                                  </p>
                                </div> -->
                    <!-- <div class="login"> -->
                    <!-- <q-btn @click="submit_request_access()" label="Submit"></q-btn> -->
                    <!-- <q-btn class="analysisbtn col-auto" unelevated rounded @click="sign_up()" label="Submit"></q-btn>
                                </div>
                              </form> -->
                    <!-- <div class="bottom-space q-my-lg">
                                <p>
                                  By signing up, you agree with our
                                  <a href="https://uniqin.ai/terms_and_conditions.html" target="_blank">Terms Conditions</a>
                                </p>
                              </div>  -->
                    <!-- <button @click="login()">login</button>
                          <p>is login? {{is_login}}</p> -->
                    <!-- </div>
                          </vs-tab>  -->
                  </vs-tabs>
                </div>

              </div>
            </div>
          </q-card-section>
        </q-card>
      </q-dialog>
    
    <!-- Amazon Connection Modal -->
    <AmazonConnectionModal
      :show="showAmazonConnectionModal"
      :userEmail="details.email"
      @skip="handleSkipConnection"
    />

</q-blur>
  </div>
</template>
<script>
import awsconfig from "../aws-exports";
import { Auth, container } from "aws-amplify";
import axios from 'axios';
Auth.configure(awsconfig);
import { ref } from 'vue'
import AmazonConnectionModal from '../components/AmazonConnectionModal.vue';
export default {
  components: {
    AmazonConnectionModal
  },
  setup() {
    return {
      password: ref(''),
      isPwd: ref(true),
      isPwdconfirm: ref(true),
    }

  },
  data() {
    return {
      is_login: true,
      src: "login_img.webp",
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      public_api: this.$store.state.PUBLIC_SIGNUP_API[process.env.VUE_APP_ENV],

      username: this.$store.state.forgot_password_email,
      details: {
        // name: "",
        email: "",
        // company: "",
        password1: "password@123",

      },
      user_status: '',
      manual: {
        email: "",
        password: "",
        // otp: '',
      },
      UserEmail: '',
      existusers: '',
      visible: false,
      is_email1_valid: false,
      is_password1_valid: false,
      // is_company_valid: false,
      // is_name_valid: false,
      is_email_valid: false,
      is_email1_error: false,
      is_password1_error: false,
      is_company_error: false,
      is_name_error: false,
      otp: '',
      emailbody: '',
      showEdit: false,
      userpassword: '',
      userconfirmpassword: '',
      newsetpassword: '',
      newconfirmpassword: '',
      resetpassword: '',
      resetconfirmpassword: '',
      oldpassword: 'Dhiva@123',
      defaultpassword: 'Password@123',
      passwordError: null,
      showpassword: false,
      showresetpassword: false,
      showEditotp: false,
      showuserprofile: false,
      showorganizationform: false,
      showblockedprofile: false,
      selectedCountry: '+91', // Default country code
      mobileNumber: '',
      countries: [
        { name: 'India', code: '91', flag: '🇮🇳' },
        { name: 'United States', code: '1', flag: '🇺🇸' },
        // Add more countries as needed with their respective flag emojis
      ],
      showsuccessmsg: false,
      showcontainer: false,
      showAmazonConnectionModal: false,
      organizationName: '',
      monthlyadsales: '',
      monthlyadcost: '',
      Typeofbusiness: '',
      operatingcountry: '',
      preferredtimezone: '',
      dropdownOptions: [
        'seller',
        'Agency',


      ],
      isPasswordSaved: false,
      code: '',
      password: '',
      confirm_password: '',

      is_code_valid: false,
      is_code_error: false,
      is_password_valid: false,
      is_password_error: false,
      is_confirm_password_valid: false,
      is_confirm_password_error: false,
      isButtonDisabled: true,

      is_setpassword_valid: false,
      is_setpassword_error: false,
      is_setconfirm_password_error: false,
      is_setconfirm_password_valid: false,
      passwordVisible: false,
      confirmpasswordVisible: false,
      resendTimer: 0,
      errorMessage: '',
      successMessage: '',
      notifyMessage: '',
      signup_error: '',
      reset_error_msg: '',

    };
  },
  created() {

    // this.$store.dispatch("setCredentials", {});
    // this.$store.dispatch("setSignedIn", false);
    // console.log("Signout")
    // Auth.signOut({global: true})
    //     .then((res)=>{
    //         console.log(res)
    //     })
    //     .catch(err=> {
    //         console.log(err)
    //     });
    // console.log("when created");
    // console.log(this.$store.state.credentials);
    // if(this.$store.state.signedIn)
    // {
    //   this.$router.push({
    //    name: "Home"
    // });
    // }
  },
  computed: {

    isVerifyButtonDisabled() {
      // Check if all otp values are filled
      return this.otp.some(value => !value);
    },
    forgot_password_url() {
      var client_id = awsconfig.aws_user_pools_web_client_id;
      var justUrl = awsconfig.oauth.domain;
      var cognitoUrl =
        "https:" +
        justUrl +
        "/forgotPassword?response_type=code&client_id=" +
        client_id +
        "&redirect_uri=";
      var baseURL = window.location.origin + "/auth/signin/";
      console.log(cognitoUrl);
      return cognitoUrl + baseURL;
    },
    isFormValid() {
      return (
        this.is_code_valid &&
        this.is_password_valid &&
        this.is_confirm_password_valid
        // Add any additional conditions here
        // (e.g., code validation)
      );
    },
    isdisablesetpassword() {
      return (
        this.is_setpassword_valid &&
        this.is_setconfirm_password_valid
      );
    },
    isdisableverify() {
      return this.otp.length !== 6;

    },
    // error_name() {
    //   var regex = /^[a-zA-Z ]{3,30}$/;
    //   if (regex.test(this.details["name"])) {
    //     this.is_name_valid = true;
    //     this.is_name_error = false;
    //     return "";
    //   } else if (this.details["name"].length < 3) {
    //     this.is_name_valid = false;
    //     this.is_name_error = false;
    //     return "";
    //   } else {
    //     this.is_name_valid = false;
    //     this.is_name_error = true;
    //     return "";
    //   }
    // },
    error_email1() {
      var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (regex.test(this.details["email"])) {
        this.is_email1_valid = true;
        this.is_email1_error = false;
        return "";
      } else if (this.details["email"].length < 4) {
        this.is_email1_valid = false;
        this.is_email1_error = false;
        return "";
      } else {
        this.is_email1_valid = false;
        this.is_email1_error = true;
        return "";
      }
    },
    error_email() {
      var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (regex.test(this.manual["email"])) {
        this.is_email_valid = true;
        this.is_email_error = false;
        return "";
      } else if (this.manual["email"].length < 4) {
        this.is_email_valid = false;
        this.is_email_error = false;
        return "";
      } else {
        this.is_email_valid = false;
        this.is_email_error = true;
        return "";
      }
    },
    error_company() {
      var regex = /^[a-zA-Z ]{3,30}$/;
      if (this.details["company"].length > 2) {
        this.is_company_valid = true;
        return "";
      } else if (this.details["company"].length < 3) {
        this.is_company_valid = false;
        return "";
      }
    },
    error_password1() {
      var regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,15}$/;
      if (regex.test(this.details["password1"])) {
        this.is_password1_valid = true;
        this.is_password1_error = false;
        return "";
      } else if (this.details["password1"].length > 6 && this.details["password1"].length < 15 || this.details["password1"].length === 0) {
        this.is_password1_valid = false;
        this.is_password1_error = false;
        return "";
      } else {
        this.is_password1_valid = false;
        this.is_password1_error = true;
        return "";
      }
    },
    error_code() {
      var regex = /^\d{6}$/gm;



      if (regex.test(this.code)) {
        this.is_code_valid = true;
        this.is_code_error = false;

        return '';


      }
      else if (this.code.length < 1) {
        this.is_code_valid = false;
        this.is_code_error = false;

        return '';

      }
      else {
        this.is_code_valid = false;
        this.is_code_error = true;
        return "";

      }

    },
    error_password() {

      var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@&$!*])[A-Za-z\d#@&$!*]{8,16}$/;

      if (regex.test(this.password)) {
        this.is_password_valid = true;
        this.is_password_error = false;

        return '';


      }
      else if (this.password.length < 1) {
        this.is_password_valid = false;
        this.is_password_error = false;

        return '';

      }
      else {
        this.is_password_valid = false;
        this.is_password_error = true;
        return "";

      }



    },
    set_password() {

      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@&$!*])[A-Za-z\d#@&$!*]{8,16}$/;


      if (regex.test(this.userpassword)) {
        this.is_setpassword_valid = true;
        this.is_setpassword_error = false;

        return '';


      }
      else if (this.userpassword.length < 1) {
        this.is_setpassword_valid = false;
        this.is_setpassword_error = false;

        return '';

      }
      else {
        this.is_setpassword_valid = false;
        this.is_setpassword_error = true;
        return "";

      }



    },
    error_confirm_password() {

      if (this.confirm_password.length < 1) {
        this.is_confirm_password_valid = false;
        this.is_confirm_password_error = false;

        return '';

      }
      else if (this.password != this.confirm_password) {
        this.is_confirm_password_valid = false;
        this.is_confirm_password_error = true;

        return '';

      }
      else {
        this.is_confirm_password_valid = true;
        this.is_confirm_password_error = false;

        return '';

      }

    },
    error_setconfirm_password() {

      if (this.userconfirmpassword.length < 1) {
        this.is_setconfirm_password_valid = false;
        this.is_setconfirm_password_error = false;

        return '';

      }
      else if (this.userpassword != this.userconfirmpassword) {
        this.is_setconfirm_password_valid = false;
        this.is_setconfirm_password_error = true;

        return '';

      }
      else {
        this.is_setconfirm_password_valid = true;
        this.is_setconfirm_password_error = false;

        return '';

      }

    },

  },
  // computed: {
  //   signInURL() {
  //     var client_id = awsconfig.aws_user_pools_web_client_id;
  //     var justUrl = awsconfig.oauth.domain;
  //     var cognitoUrl =
  //       "https://" +
  //       justUrl +
  //       "/login?response_type=code&client_id=" +
  //       client_id +
  //       "&redirect_uri=";
  //     var baseURL = window.location.origin + "/auth/signin/";
  //     console.log(cognitoUrl);
  //     return cognitoUrl + baseURL;
  //   },
  //   signedIn() {
  //     return this.$store.state.signedIn;
  //   },
  //   sub() {
  //     return this.$store.state.credentials.signInUserSession.idToken.payload
  //       .sub;
  //   },
  // },
  mounted() {
    // this.tracksignupview(); 
    console.log('Component mounted. Password:', this.manual.password);
    this.dynamic();
    this.existuser();
    this.showcontainer = true;
    // this.showuserprofile =true;

    // var form = this.$refs.contactForm;
    // form.addEventListener("submit", e => {
    //   e.preventDefault();
    //   fetch(form.action, {
    //     method: "POST",
    //     body: new FormData(document.getElementById("contactForm")),
    //   }).then(
    //     response => response.json()
    //   ).then((html) => {
    //     // you can put any JS code here
    //     this.$alert("Your query has been submitted successfully!", "success");
    //     document.getElementById("contactForm").reset();
    //   });
    // });
  },

  methods: {
    trackTermsLink() {
      // Track click on the link using Mixpanel
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);

      this.$mixpanel.track('Terms and Conditions Clicked', {
        Path: 'User clicked terms and conditions from Login page to Terms and conditions',
        UserEmail: localStorage.getItem('email'),
        Date: new Date().toDateString(),
        Page: 'Terms and Conditions',
        Time: istTime,



      });
    },
    closecall() {
      this.showEdit = true;
      this.showresetpassword = false;

    },
    back_resetpassword() {
      this.showpassword = true;
      this.showEdit = false;

    },
    async reset_password() {
      // Collect confirmation code and new password, then
      const resetcode = localStorage.getItem('email')

      if (this.is_code_error || this.is_password_error || this.is_confirm_password_error) {
        this.$alert("Please enter proper credentials and try again", "Could not reset", "error");

      }


      console.log('username_', this.username)
      console.log('passswordd', this.password)
      Auth.forgotPasswordSubmit(this.details.email, this.code, this.password)
        .then(data => {
          console.log(data);
          this.$q.loading.hide();
          this.code = "";
          this.password = "";
          this.confirm_password = "";
          this.$q.notify({
            type: 'positive',
            message: 'Password created succesfully'
          })

          this.$q.loading.show({
            message: 'Your Password is saved...Please Wait'

          });
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          const istTime = now.toLocaleString('en-US', options);
          const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);

          this.$mixpanel.track('Resetting password', {
            UserEmail: this.UserEmail,
            Path: 'User accessed the reset password popup and logged in successfully!.',
            Time: istTime,
            Date: istDateAndDay,

          });
          this.manual_login();


        }

        )
        .catch(err => {
          console.log(err);
          this.$q.loading.hide();
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const istTime = now.toLocaleString('en-US', options);
          this.$mixpanel.track('Error : Resetting password', {
            UserEmail: this.UserEmail,
            Error: 'The user encountered an issue while attempting to access the reset password popup!.',
            Date: new Date().toISOString(),
            Time: istTime
          });
          this.$alert("Could not change password", "Error occured", "error");
          this.reset_error_msg = 'Invalid Code , Please check again !'

        });
      this.manual.email = this.details.email
      this.manual.password = this.password


    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    ExistpasswordVisible() {
      this.visible = !this.visible;

    },
    toggleconfirmPasswordVisibility() {
      this.confirmpasswordVisible = !this.confirmpasswordVisible;
    },
    resetpassword_popup() {
      this.showresetpassword = true;

    },
    backblockeduser() {
      this.showcontainer = true;
      this.showblockedprofile = false;
    },

    async send_confirmation_code() {
      let reset_email = localStorage.getItem('email')
      console.log('resetemail', reset_email)

      this.$q.loading.show({
        message: 'Submitting your request, please wait..'

      });
      // Send confirmation code to user's email
      Auth.forgotPassword(reset_email)
        .then(data => {


          this.$q.loading.hide();

          this.$store.dispatch("setForgotPasswordEmail", reset_email);

          this.showresetpassword = true;
          this.showEdit = false;
          // this.showpassword = false;
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          const Seconds = { timeZone: 'Asia/Kolkata', second: 'numeric' };
          const istTime = now.toLocaleString('en-US', options);
          const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);
          const seconds = now.toLocaleTimeString('en-US', Seconds);
          this.$mixpanel.track('Reset Password', {
            UserId: this.UserEmail,
            Path: 'User accessed the reset password popup and OTP sent Successfully!',
            Time: istTime,
            Date: istDateAndDay,
            TimeSpend: `The user spent ${seconds} seconds!`
          });


          console.log(data)

        })
        .catch(err => {
          this.$q.loading.hide();
          this.$mixpanel.track('Failed Reset Password', {
            UserEmail: this.UserEmail,
            Error: 'The user encountered an issue while attempting to access the reset password popup.'
          });

          this.$alert("Could not submit query, some error has occured !", "Sorry", "error");

          console.log(err);
          return;

        });

    },
    back() {
      this.$mixpanel.track('Set Passowrd Field', {
        Info: 'The user navigated back to the previous popup, specifically the SignIn or login page, as part of their interaction flow.'
      })
      this.showuserprofile = false;
      this.showEditotp = true;

    },
    // trackPageDuration() {
    //   const endTime = new Date();
    //   const duration = (endTime - this.startTime) / 1000; // Convert milliseconds to seconds
    //   this.$mixpanel.track('Page View - SignUp/Login', {
    //     page: "SignUp/Login",
    //     duration_seconds:` User spends ${duration} seconds`
    //   });
    // },
    dynamic() {

     
      this.UserEmail = localStorage.getItem('email');

      console.log('dynamic email', this.UserEmail)


    },
    existuser() {
      this.existusers = localStorage.getItem('email')

    },
    handleDialogClick(event) {
      // Prevent the default behavior of the click event to stop it from closing the popup
      event.preventDefault();
    },
    mainelement() {
      this.showcontainer = true;
      this.showEditotp = false;
    },
    parseEmailBody(emailbody) {
      const codePattern = /verification code: (\d+)/i;
      const match = emailBody.match(codePattern);
      if (match) {
        return match[1]; // Extract the code from the regex match
      }

      return null;
    },
    async changeUserPassword() {
      try {
        await Auth.changePassword(this.oldpassword, this.userpassword);
        console.log('Password changed successfully.');
      } catch (error) {
        console.error('Error changing password:', error);
        // Handle password change errors
      }
    },

    async storePassword() {
      this.notifyMessage = 'Please Wait for Some times'
      this.$q.loading.show({
        message: 'Please wait...'

      });


      const Authticate_email = localStorage.getItem('email')
      const passwrd = localStorage.getItem('password')
      console.log('user pwd', this.userpassword)
      console.log('user confirm pwd', this.userconfirmpassword)
      const passwordregex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@&$!*])[A-Za-z\d#@&$!*]{8,16}$/;


      if (!passwordregex.test(this.userpassword)) {
        this.passwordError = 'Password must be at least 8 characters long and include at least one numeric digit, one uppercase letter, and only any of these special characters @!#$&*'

      }
      else if (this.userpassword !== this.userconfirmpassword) {
        this.passwordError = 'Password do not match'

      }
      else {
        try {
          console.log('emaill', Authticate_email)
          console.log('paass', passwrd)
          console.log('user confirm pwd', this.userconfirmpassword)

          const signInResult = await Auth.signIn(Authticate_email, passwrd);

          const user = await Auth.currentAuthenticatedUser({});
          console.log('authenticationuser', signInResult)
          console.log('oldpassword', this.oldpassword);
          console.log('userpassword', this.userpassword);
          this.details.email = Authticate_email;
          this.manual.password = this.userpassword;
          const data = await Auth.changePassword(user, passwrd, this.userpassword);
          // const data = await Auth.changePassword(user, this.userpassword, this.userpassword);
          console.log('data', data)
          const verified_url = `${this.public_api}/signup/update_user`
          const putdata = {
            user: Authticate_email,
            current_stat: 'verified',
            new_stat: 'active'
          };
          axios.put(verified_url, putdata)
            .then(response => {
              console.log('responsedata', response.data)


            })
            .catch(error => {
              console.log('error', error)

            });


          setTimeout(() => {

            this.$q.loading.hide();
            this.manual_login();


          }, 2000);

          this.passwordError = null;
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          const Seconds = { timeZone: 'Asia/Kolkata', second: 'numeric' };
          const istTime = now.toLocaleString('en-US', options);
          const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);
          const seconds = now.toLocaleTimeString('en-US', Seconds);
          this.$mixpanel.track('Setting New password', {
            UserEmail: this.UserEmail,
            Path: 'The user has navigated to the "Set New Password" popup and has successfully set a new password.',
            Time: istTime,
            Date: istDateAndDay,
            TimeSpend: `The user spent ${seconds} seconds!`
          });



        }
        catch (error) {
          console.error('Error storing password:', error);
          // this.passwordError = 'Error storing the password.';
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const istTime = now.toLocaleString('en-US', options);
          this.$mixpanel.track('Failed Setting New Password', {
            UserEmail: this.UserEmail,
            Error: 'The user encountered an issue while attempting to set a new password in the "Set New Password" popup.',
            Date: new Date().toDateString(),
            Time: istTime
          });
        }
      }
      this.isPasswordSaved = true;



    },
    success() {
      const organizationform = localStorage.getItem('email')
      const exist_email = 'dhivakarvasu2000@gmail.com'
      if (exist_email === organizationform) {
        this.showorganizationform = true;
      }
      else {
        this.showsuccessmsg = true;
      }
    },

    goback() {
      this.showpassword = false;

    },
    sendcontainer() {
      this.sendOTP();
      this.submitForm();

    },
    verify() {

      var getEmail = localStorage.getItem('email');
      const username = getEmail;
      const code = this.otp; // The OTP code received via email
      console.log('username', username)
      console.log('otp', code)

      Auth.confirmSignUp(username, code)
        .then(data => {
          if (this.user_status == 'new') {
            const verified_url = `${this.public_api}/signup/enteruser/?user=${username}&stat=verified`
            const postdata = {
              user: username,
              stat: 'verified',
            };
            axios.post(verified_url, postdata)
              .then(response => {
                console.log('responsedata', response.data)

              })
              .catch(error => {
                console.log('error', error)

              });
          } else if ((this.user_status == 'invited')) {
            const verified_url = `${this.public_api}/signup/update_user`
            const putdata = {
              user: username,
              current_stat: 'invited',
              new_stat: 'verified'
            };
            axios.put(verified_url, putdata)
              .then(response => {
                console.log('responsedata', response.data)

              })
              .catch(error => {
                console.log('error', error)

              });
          }
          this.showEditotp = false;
          this.$q.loading.show({
            message: 'Please wait...'

          });
          setTimeout(() => {

            this.$q.loading.hide();
            this.showuserprofile = true;


          }, 2000);


          console.log('User confirmed successfully:', data);
          this.successMessage = 'OTP verified Successfully!'
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          const Seconds = { timeZone: 'Asia/Kolkata', second: 'numeric' };
          const istTime = now.toLocaleString('en-US', options);
          const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);
          const seconds = now.toLocaleTimeString('en-US', Seconds);
          this.$mixpanel.track('OTP verification', {
            UserEmail: this.UserEmail,
            Path: 'The user has initiated the OTP verification process, and the verification has been successfully completed.',
            Time: istTime,
            Date: istDateAndDay,
            TimeSpend: `The user spent ${seconds} seconds!`
          });


        })
        .catch(err => {

          this.errorMessage = 'Invalid OTP! please check once again.'
          console.error('Error confirming user:', err);
          this.$mixpanel.track('Error: OTP verification', {
            UserEmail: this.UserEmail,
            Error: 'The user has initiated the OTP verification process, and the verification has been failed!'
          });
        })


      this.otp = '';

    },
    async resendcode() {
      this.$mixpanel.track('OTP Verification', {
        Info: 'The user encountered an issue with the code and subsequently initiated a request to resend the OTP (One-Time Password) for authentication.',
        UserEmail: localStorage.getItem('email')
      })
      this.resendTimer = 30;

      // Decrease the timer every second
      const timerInterval = setInterval(() => {
        this.resendTimer--;

        // Check if the timer has reached 0
        if (this.resendTimer === 0) {
          clearInterval(timerInterval); // Stop the timer
        }
      }, 1000);
      const username = localStorage.getItem('email')
      try {
        await Auth.resendSignUp(username);
        this.$q.notify({
          type: 'positive',
          message: 'Code Sended Sucessfully!'
        })
        console.log('code resent successfully')
      }
      catch (err) {
        this.$q.notify({
          type: 'negative',
          message: 'User already exists. Please contact Admin',
        })
        console.log('error resending code : ', err);
      }

    },
    popup() {
      this.showEdit = true;


    },
    focusNextBox(index, event) {
      const value = event.target.value;
      this.otp.splice(index, 1, value);

      // Move focus to the next input box
      if (index < 6 && value !== '') {
        this.$refs[`otpInput${index + 1}`].focus();
      }

    },
    handlebackspace(index, event) {
      if (event.key === 'Backspace' && !this.otp[index] && index > 1) {
        event.preventDefault();
        this.otp[index] = '';
        this.$refs[`otpInput${index - 1}`].focus();

      }

    },
    handlePaste(event) {
      event.preventDefault();

      const pastedData = (event.clipboardData || window.clipboardData).getData('text');
      const pastedDigits = pastedData.match(/\d/g);

      if (pastedDigits && pastedDigits.length === 6) {
        pastedDigits.forEach((digit, index) => {
          this.otp.splice(index + 1, 1, digit);
        });
      }
    },
    passwordpopup() {
      this.showpassword = true;
    },
    close() {
      this.showpassword = false;

    },
    cancel() {
      this.$mixpanel.track('OTP Verification', {
        Info: 'The user navigated back to the previous popup, specifically the SignIn or login page, as part of their interaction flow.',
        UserEmail: localStorage.getItem('email')
      })

      this.showEditotp = false;
    },
    close() {
      this.showuserprofile = false;

    },
    sendOTP() {
      const otp = Math.floor(1000 + Math.random() * 9000);
      alert(`OTP sent to ${this.manual.email}: ${otp}`);

    },
    call() {
      window.location.href = "tel:+918296168717";
    },
    loginviaotp() {
      this.showEditotp = true;
    },
    showpw() {
      this.showpassword = true;
    },
    submitForm() {


      const exist_email = 'support@uniqin.ai'
      const new_user = 'dhivakarvasu2000@gmail.com'
      const new_user1 = 'dhivakar@gmail.com'
      if (this.manual.email.trim() !== '') {

        if (exist_email === this.manual.email) {

          this.showpassword = true;

        }
        else if (new_user && new_user1 === this.manual.email) {
          this.showEditotp = true;
        }
      }
      else {
        this.$q.notify({
          type: 'negative',
          message: "Please fill the email field",
        });
      }

    },
    async submit_request_access() {
      if (
        !(
          this.is_email1_valid
          // &&this.is_company_valid 
          // && this.is_name_valid
        )
      ) {
        this.$alert(
          "Please check invalid fields and try submitting again",
          "Invalid fields detected!",
          "error"
        );
        return;
      }
      this.$q.loading.show({
        message: "Submitting your request, please wait..",
      });
      var form = this.$refs.contactForm;
      fetch(
        "https://script.google.com/macros/s/AKfycbz77ip8fV7MuN3J7q25WRiVD3cDRzrNx2u6DXjudw7i64AP4j_iQKJ04zayZHN11J8h3g/exec",
        {
          method: "POST",
          body: new FormData(form),
        }
      )
        .then((response) => response.json())
        .then((html) => {
          // you can put any JS code here
          console.log("form", form);
          this.$q.loading.hide();
          // this.details["name"] = "";
          this.details["email"] = "";
          // this.details["company"] = "";
          this.defaultpassword = "password@123";
          // this.$alert(
          //   "Your request has been submitted successfully!, we will contact you shortly",
          //   "Great!",
          //   "success"
          // );
          //form.reset();
        });
    },
    async login() {
      //  const googleUser = await this.$gAuth.signIn();
      //  console.log("googleUser", googleUser);
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track('Google SignIn', {
        Path: 'User Accessed Through Google',
        Time: istTime,
        Date: new Date().toDateString(),
        Status: 'Success'



      })

      try {
        // const googleUser = await this.$gAuth.signIn();
        // console.log("googleUser", googleUser);


        Auth.federatedSignIn({ provider: "Google" });
      } catch (error) {
        console.log("error:", error);
      }
    },
    change_image(temp) {
      if (temp == "login") this.src = "login_img.webp";
      if (temp == "request_access") this.src = "login_img2.webp";
    },

    async manual_login() {
      this.showpassword = false;
      this.showcontainer = false;
      const Email = localStorage.getItem('email');
      const pwd = localStorage.getItem('password')
      console.log('manual email', this.manual.email);
      console.log('manual pwd', this.manual.password);

      this.$q.loading.show({
        message: "Logging you in, please wait..",
      });
      try {
        const user = await Auth.signIn(
          this.details['email'],
          this.manual["password"]
        );
        const now = new Date();
        const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
        const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const Seconds = { timeZone: 'Asia/Kolkata', second: 'numeric' };
        const istTime = now.toLocaleString('en-US', options);
        const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);
        const seconds = now.toLocaleTimeString('en-US', Seconds);
        this.$mixpanel.track('Logged In', {
          UserEmail: this.UserEmail,
          Path: 'User stepped into application and logged in successfully.',
          Time: istTime,
          Date: istDateAndDay,
          TimeSpend: `The user spent ${seconds} seconds!`,
          Action: 'User in Existing passowrd field',
          Status: 'Sucess'

        });
        console.log('user', user)
      } catch (error) {
        console.log("error signing in", error);
        console.log("username", this.details['email']);
        console.log("password", this.manual.password);
        this.$q.loading.hide();
        this.$mixpanel.track('Error While logging in', {
          UserEmail: this.UserEmail,
          Error: 'The user encountered an issue while attempting to log in using the existing password field.',
          Time: new Date().toISOString(),
          Action: 'User in Existing passowrd field',
          Status: 'Failed'

        });
        this.$alert(
          "please enter correct email id and password and try again",
          "Could not Log in",
          "error"
        );
      }
      console.log("environment is: ", process.env.VUE_APP_ENV);
      Auth.currentAuthenticatedUser()
        .then((creds) => {
          this.$q.loading.hide();
          console.log("creds", creds);
          // Show Amazon connection modal for new users
          const isNewUser = localStorage.getItem('onboarding_pending') === 'true';
          const hasConnection = localStorage.getItem('amazon_connected') === 'true';

          if (isNewUser && !hasConnection) {
            this.showAmazonConnectionModal = true;
            localStorage.removeItem('onboarding_pending');
          } else {
            this.$router.push({
              name: "SignIn",
            });
          }
          this.$store.dispatch("setCredentials", creds);
          this.$store.dispatch("setSignedIn", true);

        })
        .catch((error) => {
          this.$store.dispatch("setSignedIn", false);
        });
    },
    // async otp_login(){
    //   this.showorganizationform= true;
    // },
    proceed() {
      this.showsuccessmsg = true;


    },
    async create_new_user() {
      try {
        console.log("useremail")
        const { user } = await Auth.signUp({
          username: this.details.email,
          password: this.defaultpassword,
          attributes: {
            email: this.details.email,
          },
        });

        console.log(user);
        return;
      } catch (error) {
        this.$q.loading.hide();
        this.$alert(
          "user already exists, please check your credentials and try again",
          "Could not sign up",
          "error"
        );
        console.log("error signing up:", error);
      }

    },
    handleSkipConnection() {
      // User skipped Amazon connection
      this.showAmazonConnectionModal = false;
      this.$router.push({ name: 'SignIn' });
    },
    async sign_up() {
      this.$mixpanel.track_pageview({ "page": "Signup/Login" });
      const userId = localStorage.getItem('email');


      this.$mixpanel.identify(userId);

      this.$mixpanel.people.set({
        $email: userId,
      });
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const istTime = now.toLocaleString('en-US', options);
      const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);

      this.$mixpanel.track('Sign Up Started', {
        UserEmail: localStorage.getItem('email'),
        Path: 'User Stepped into Signup/login page',
        Time: istTime,
        Date: istDateAndDay,



      })
      if (this.is_email1_valid) {


        let password = this.details["password1"];
        var email = this.details["email"];
        localStorage.setItem('email', this.details.email)
        localStorage.setItem('password', this.defaultpassword)
        this.UserEmail = localStorage.getItem('email');
        this.$q.loading.show({
          message: "Submitting your request, please wait..",
        });

        // const exist_email = 'dhivakarvasu2000@gmail.com'
        // const new_user = 'dhivakar.v@uniqin.ai'
        // const invited_user = 'dhivakarv3322@gmail.com'

        const apiUrl = `${this.public_api}/signup/get_user?user=${email}`;

        axios.get(apiUrl)
          .then(async (response) => {
            // Handle the response
            console.log('Response Data:', response.data);
            const statusCode = response.data.statusCode;
            const responseBody = response.data.body;

            if (statusCode === 200) {
              this.$q.loading.hide();
              // Handle success scenario
              this.user_status = responseBody;
              if (responseBody === 'active' || responseBody === 'suspended') {
                // Existing user logic
                this.showpassword = true;
                const now = new Date();
                const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
                const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

                const istTime = now.toLocaleString('en-US', options);
                const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);

                this.$mixpanel.track('Login Started', {

                  Info: 'Exist User',
                  UserEmail: localStorage.getItem('email'),
                  Path: 'User accessed Password field to signIn',
                  Time: istTime,
                  Date: istDateAndDay,


                })

                try {
                  await Auth.signIn(email, password);
                  console.log('User signed in successfully');
                  // Additional logic for signed-in user
                } catch (signInError) {
                  console.error("Error signing in:", signInError);
                  // Handle sign-in error
                }
              } else if (responseBody === 'invited' || responseBody === 'new') {
                const now = new Date();
                const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
                const DateandDay = { timeZone: 'Asia/Kolkata', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                const istTime = now.toLocaleString('en-US', options);
                const istDateAndDay = now.toLocaleDateString('en-US', DateandDay);
                this.$mixpanel.track('Signup Process', {

                  Info: 'New/Invited User',
                  UserEmail: localStorage.getItem('email'),
                  path: 'User accessed OTP verification Process',
                  Time: istTime,
                  Date: istDateAndDay,


                })
                // Invited user logic
                const loadingInstance = this.$q.loading.show({
                  message: "Creating new user, please wait...",
                });
                try {
                  await this.handleSignup(email, password);
                  console.log("Setting showEditotp to true...");
                  this.showEditotp = true;
                  console.log("showEditotp set to true.");
                } catch (error) {
                  localStorage.setItem('email', email)
                  if (error.code === "UsernameExistsException") {

                    // await this.resendcode()
                    this.showEditotp = true;
                    this.$q.loading.hide();
                  } else {
                    console.error("Error creating new user:", error)
                  }

                  // Handle errors, if any
                  console.log("Error creating new user(status unconfirmed):", error);
                } finally {

                  this.$q.loading.hide();
                }
              }
              else if (responseBody === 'verified') {
                // New user logic
                // this.$q.loading.hide();
                this.showuserprofile = true;
              }
              else if (responseBody === 'blocked') {
                this.$mixpanel.track('Blocked User', {

                  Info: 'Blocked User!',
                  UserEmail: localStorage.getItem('email'),



                })
                this.showblockedprofile = true;

              }
              else {
                this.$q.notify({
                  type: 'negative',
                  message: 'Please check for any errors you might be encountering.'
                }
                )
              }
            }


          })
          .catch(error => {
            this.$q.loading.hide();
            this.$mixpanel.track('User Already Exists', {
              UserEmail: localStorage.getItem('email'),
              Error: 'User already Exists!.'
            })
            this.$alert(
              "user already exists, please check your credentials and try again",
              "Could not sign up",
              "error"
            );
            console.error('Error fetching data:', error);
          })
      }
      else {
        if (this.is_email1_valid) {
          this.signup_error = ''
        }
        else {
          this.signup_error = 'Invalid email. Please provide a valid email address.'
          console.log('Invalid email. Please provide a valid email address.')
        }
      }



    },
    async handleSignup(email, password) {
      try {
        console.log("useemail")
        const { user } = await Auth.signUp({
          username: email,
          password: this.defaultpassword,
          attributes: {
            email: email,
          },
        });


        this.submit_request_access();

        console.log(user);
        return;
      } catch (error) {
        this.$q.loading.hide();
        this.showcontainer = false;
        this.showEditotp = false;
        this.$alert(
          "user already exists, please check your credentials and try again. If you want to continue again.!!REFRESH THE PAGE!!",
          "Could not sign up",
          "error"
        );
        // this.$q.notify({
        //   type:'negative',
        //   message:'user already exists, please check your credentials and try again'
        // })
        console.log("error signing up:", error);
        throw error;
      }

    }


  },
};
</script>
<style>
@import "./style.css";
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');

* {
  font-family: 'poppins' sans-serif;
}

.wrapper {
  display: block;
  justify-content: center;
}

.form-container {
  display: flex;
  justify-content: left;
}

.input-field {
  width: 60%;
  margin-left: 1rem;
  /* Add other styles as needed */
}

.icons {
  margin-left: 0rem;
}

.login {
  margin-top: 0%;
  /* Add other styles as needed */
}

.analysisbtn {
  width: auto;
  /* Set a specific width for the button */
}

.bottom-space {
  /* Add your existing styles here */

  /* Additional styles for mobile view */
  text-align: center;
  /* Center the text in mobile view */
}

.workEmail {
  margin-top: 1.5rem;
}

.input-field>.icons {
  margin-top: 3px;
}

.input-field>label .icons {
  margin-top: 3px;
}

@media only screen and (max-width: 600px) {
  .form-container {
    flex-direction: column;
    margin-left: 3rem;
    width: 80%;




  }

  .workEmail {
    text-align: center;
  }

  .input-field {
    width: 50%;
    margin-left: 1rem;

    margin-bottom: 1rem;
    /* Add some space between elements */
  }

  .input-field>input,
  .icons {
    margin-left: 5rem;
  }

  .input-field>.icons {
    margin-top: 3px;
  }

  .input-field>label .icons {
    margin-top: 3px;
  }


  .login {
    width: 60%;
    margin-top: 1rem;
    /* Adjust margin as needed */
  }

  .login>button {
    margin-left: 5rem;
  }

  .bottom-space p {
    display: block;
    text-align: center;
    /* Center the text in mobile view */
  }

  .bottom-space a {
    display: block;
    margin-top: 0.5rem;
    /* Adjust as needed to add space between lines */
  }
}

.signupPage {
  /* background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  z-index: 2;
  overflow-x: hidden !important; */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;

}

@media only screen and (max-width: 600px) {
  .signupPage {
    width: 80%;
    max-width: none;
  }
}

.verify {
  width: 100%;
  background-color: #378CEF;
  color: white;
  font-size: medium;
  font-weight: bold;
  margin-top: 20px;
  border-radius: 15px;
}

.verificationForm {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;

}

.otp-box {
  margin-left: 0px;
  margin-top: 0px;
  width: 100%;
  background-color: white;
  border: 1px solid #A9C8EB;
  border-bottom: 1px solid #ACCAEB !important;
}

.enterotp {
  margin-bottom: 0px;

  color: black;
  font-weight: bold;
  text-align: left;
}

.timer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.verify-p {
  /* Add your existing styles here */

  /* Additional styles for responsiveness */
  text-align: left;
  /* Center the text by default */
}

.verify-p p {
  /* Add your existing styles for the paragraph here */

  /* Additional styles for responsiveness */
  margin: 0;
  /* Reset margin for default styling */
  padding: 10px;
  white-space: normal;
  /* Add padding as needed */
}

.closing-element {
  display: flex;
  justify-content: space-between;
}

.closing-element .qicon {
  font-size: x-large;
  cursor: pointer;
}

.icon-p {
  display: flex;
  /* justify-content: center; */
}

.icon-p>p {
  font-size: x-large;
  font-weight: bold;

}

.resendotp-p {
  display: flex;
}

@media only screen and (max-width: 600px) {
  .verificationForm {
    width: 80%;
    max-width: none;
  }

  .otp-card-inputs {
    display: flex;
    justify-content: center;
  }

  .otp-card-inputs>.otp-box {
    width: 60%;
  }

  .otp-card-inputs>.verify {
    width: 60%;
    display: flex;
    justify-content: center;
  }

  .enterotp {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }

  .verify-p {
    text-align: center;
    /* Align text to the left on larger screens */
  }

  .verify-p p {
    display: block;
    text-align: center;

    /* Keep the text on a single line on larger screens */
  }

  .timer .resendotp-p {
    display: block;
    margin-bottom: 0px;

  }

  .timer .resendotp-p p {
    margin-bottom: 0rem;
  }

  .timer .resendotp-p a {
    margin-top: 0rem;
    margin-left: 2rem;
  }

  .verify-p p strong {
    display: block;
    margin-top: 0rem;
  }

  .closing-element p {
    margin-left: 1rem;

  }

  .closing-element .qicon {
    margin-right: 1rem;
  }

  .icon-p {
    display: flex;
    justify-content: left;
  }

  .icon-p img {
    width: 50px;
    /* Adjust image size for mobile */
    height: 50px;
  }

  .icon-p p {
    font-size: medium;
    font-weight: bold;
    margin-top: 0.2rem;
    /* Adjust paragraph size for mobile */
  }
}

.input-group {
  display: flex;
  align-items: center;
  margin-top: 5%;
}

.setpassword {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;

}

@media only screen and (max-width:600px) {
  .setpassword {
    width: 80%;
    max-width: none;
  }

  .input-group button {
    width: 60%;
  }
}

.passwordpage {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;
}

@media only screen and (max-width: 600px) {
  .passwordpage {
    width: 80%;
    max-width: none;
  }
}

.reset_popup {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;

}

@media only screen and (max-width: 600px) {
  .reset_popup {
    width: 80%;
    max-width: none;
  }
}

.showresetpassword {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;
}

.reset-code input {
  width: 100%;
}

.visibility {
  margin-top: 1rem;
}

@media only screen and (max-width: 600px) {
  .showresetpassword {
    width: 80%;
    max-width: none;
  }

  .reset-code input {
    width: 40%;
  }

  .visibility input {
    width: 50%;
  }
}




.blockedprofile {
  border: 2px solid #e88888;
  background-color: #C9E8FF;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);
  left: 50%;
  min-height: 565px;
  min-width: 510px;
  padding: 10px;
  position: fixed;
  transform: translate(-50%, -50%);
  width: 510px;
  z-index: 2;
  top: 50%;
  overflow-x: hidden !important;

}



.largeScreenHome {
  margin-top: -2rem;
}

.signin {
  align-content: center;
}

.signed {
  margin-top: 7%;
}

.call {
  cursor: pointer;
}

.container {
  display: flex;
  width: 100%;
  height: 100%;
  /* justify-content: center; */
  /* align-items: center; */
  position: relative;
}


#left-panel {

  width: 410px;
  height: 500px;
  position: relative;
  box-shadow: 0px 7.5px 25px #031d8d63;
  border: 3px solid lightblue;
  border-radius: 32.5px 0px 0px 32.5px;
  opacity: 1;

}

#left-panel .note {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 30%;
  width: 87%;
  padding: 30px 15px;
  font-size: 15px;
  background: rgba(0, 0, 0, 0.3);
  mix-blend-mode: hard-light;
  border-radius: 20px;
  color: white;
}

#left-panel .note ol {
  margin-left: 13px;
  opacity: 1 !important;
  font-weight: 600 !important;
}

#left-panel .note p {
  font-size: 15px;
  opacity: 1;
  font-weight: 600 !important;
}

#left-panel img {
  object-fit: cover;
  width: auto;
  height: 100%;
  border-radius: 32.5px 0px 0px 32.5px;
}

@keyframes backgroundAnimation {
  0% {
    background-color: #c59bb6;
  }

  25% {
    background-color: #c8cbc8;
  }

  50% {
    background-color: #dddde4;
  }

  75% {
    background-color: #cbc0cb;
  }

  100% {
    background-color: #dbdbd0;
  }
}

.right {
  margin: 0%;

  width: 500.125px;
  height: 300px;
  z-index: 100;
  /* UI Properties */
  /* background: transparent; */
  /* background: #FFFFFF 0% 0% no-repeat padding-box; */
  /* backdrop-filter: blur(40px); */
  border: 3px solid lightblue;
  /* border-left: none; */
  /* box-shadow: 0px 25px 25px #10268963; */
  border-radius: 32.5px 32.5px 32.5px 32.5px;
  opacity: 1;
  /* animation: backgroundAnimation 30s infinite;  */
  background: #FFFFFF;
  /* background: linear-gradient(90deg, rgba(166,166,154,1) 0%, rgba(227,200,194,1) 0%); */
}

.analysisbtn {
  /* animation: backgroundAnimation 30s infinite; */
  /* background-color: #dbdbd0; */
  background: transparent;
  height: 53px;

}

.vs-tabs--li button.vs-tabs--btn {
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 17px;
  font-weight: 500;
  opacity: 0.8;
}

.activeChild button.vs-tabs--btn {
  padding-top: 12px;
  padding-bottom: 12px;
  font-weight: 700;
  color: rgb(55, 140, 239);
  opacity: 1;
}



.line-vs-tabs {
  background: #378CEF none repeat scroll 0% 0% !important;
  top: 45px !important;
  height: 3px !important;
  width: 100px;
  /* margin-left: 9px !important; */

}

.input-field {

  position: relative;
  height: 50px;
  line-height: 50px;
  /* margin: 11px auto; */
  margin-left: 0px;
  margin-right: 20px;
  margin-top: 0%;
  width: 70%;
  /* border: 2px solid rgb(16, 38, 137); */
  /* background-color: #bf1dbf; */
}

.label-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #aaa;
  transition: 0.2s all;
  cursor: text;
  padding: 0 40px;
  font-size: 15px;
}

.label-2 {
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  width: 3%;
  color: #aaa;
  transition: 0.2s all;
  cursor: text;
  padding: 0 40px;
  font-size: 15px;
}

.label-3 {
  position: absolute;
  top: 0;
  right: 0;
  left: auto;

  color: #aaa;
  transition: 0.2s all;
  cursor: text;
  padding: 0 15px;
  font-size: 15px;

}

.label-3 .valid-icons {
  margin-top: 15px;
  width: 22px;
  height: auto;

}

input {
  width: 100%;
  border: 0;
  outline: 0;
  padding: 0rem 40px;
  border-radius: 3px;
  box-shadow: none;
  color: #111;
  font-size: 13x;
  outline: none;
  border-bottom: 2px solid #EBF0F4;
}

input:invalid {
  outline: 0;

}

input:focus,
input:valid {
  background-color: #EBF0F4;
  /* outline: none; */
  /* border: 2px solid rgb(16, 38, 137); */
}

input:focus~.label-1,
input:valid~.label-1 {
  font-size: 11px;
  top: -17px;

  /* display: none; */


}

.input-field .icons {
  position: absolute;
  left: 0;
  top: 8px;
  padding: 9px 8px;
  color: #aaa;
  transition: 0.3s;
}





.login button {
  width: 100%;
  display: inline-block;
  border: none;
  background-color: #152464;
  color: white;
  padding: 0px 20px;
  border-radius: 8px;
  font-size: 16px;
}

.login button:hover {
  scale: 1.005;

  cursor: pointer;
}

.forgot-password span {
  color: #E70B89;
  display: flex;
  justify-content: center;
}

.google-login {
  text-align: center !important;
}

.google-login img {

  box-shadow: rgba(130, 113, 113, 0.35) 0px 5px 15px;
  border-radius: 8px;

}

.google-login img:hover {

  scale: 1.005;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  cursor: pointer;

}

.space {
  text-align: center;
}

.space p {
  color: #9D9D9D;
}

.bottom-space {
  text-align: center;
  font-size: 14px;
  margin-top: 5%;
}

.bottom-space a {
  color: #276AB3;
}

.password-caption {
  color: #E70B89;
}

pre {
  font-family: 'Poppins', sans-serif;

}

pre a {
  color: #111;
}

.event-listeners {
  height: 50px;
  display: flex;
  width: 430px;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: -100;
}

#a,
#b {
  height: 47px;
  width: 50%;
}

.box-pattern img {
  position: absolute;
  top: -60px;
  left: 69%;
}

/* .main-container{
    background-image: white;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
    margin: 0;

} */
.sub-container {
  background-color: white;
  border-radius: 20px;
  /* padding: 10px; */
  padding: 0;
  margin: 0;
  max-width: 500px;
  overflow-y: hidden;
  /* border: 2px solid blue; */
}

.password-container {
  display: flex;
  justify-content: space-between;
}

.input-password {
  display: flex;
  justify-content: space-evenly;
  margin-top: 5%;

}

.back {
  display: flex;
  justify-content: space-between;

}

.input-password input {
  height: 40px;
  border: 2px solid red;
  border-right: none;
  padding: 0%;
}

.input-container {
  width: 100%;
  border: none;
  background-color: white;
  border-bottom: 1px solid red;
  padding: 10px;
  display: flex;
}

.q-btn-login {
  width: 100%;
  background-color: rgb(78, 29, 8);
  color: white;
  /* margin-top: 20%; */
}

.Reset-form {
  background-color: white;
  height: 100%;
}

.password-reset {
  display: block;
  /* justify-content: center; */
  /* text-align: center; */
}

.password-inputcontainer {
  display: block;
  justify-content: center;
}

.password-field {
  width: 50%;
  margin: 20px auto;

}

.confirmpassword-field {
  width: 50%;
  margin: 20px auto;
}

.img-field {
  display: flex;
  justify-content: center;
}

.button-container {
  display: flex;
  justify-content: center;
}

.btn {
  background-color: rgb(83, 83, 220);
  color: white;
  margin: 25px auto;
}

.main-container-otp {
  background-image: rgb(68, 43, 43);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0;

}

.sub-container-otp {
  background-color: white;
  border-radius: 20px;
  /* padding: 5px; */
  max-width: 500px;
  /* text-align: center; */
  /* border: 2px solid blue; */
}

h6 {
  font-size: 30px;
  font-weight: bold;
  color: rgb(31, 25, 17);
  margin: 3%;
  margin-left: 0;
}

/* .otp-card-inputs {
  display: flex; 
  justify-content: center;
  align-items: center;
  background: unset; 
  border: 1px solid grey;

} */

.code {

  padding: 10px;
  margin: 10px;
  border: 1px solid grey;
  border-bottom: 1px solid grey !important;
  border-radius: 5px;
  text-align: left;
  height: 60px;
  width: 60px;
  font-weight: bold;
  margin-right: 0px;
  background-color: white;
  /* background-color: white; */


}

.resend-code {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

@media (max-width: 900px) {
  .otp-card-inputs {
    flex-wrap: wrap;
  }

  .code {
    font-size: 24px;
    height: 40px;
    max-width: 50px;
    font-size: bold;
    /* border: 2px solid grey; */

  }

}

.code::-webkit-outer-spin-button,
.code::-webkit-inner-spin-button {
  -webkit-appearance: none;
}


.confirm-button {
  width: 100%;
  background-color: #378CEF;
  color: white;
  font-size: medium;
  font-weight: bold;
  margin-top: 20px;
  /* border-radius: 15px; */

}

/* .userinput{
  display: block;
} */
.input-userprofile {

  height: 40px;
  margin-top: 3%;
  border: 2px solid red;
  margin-bottom: 3%;
  padding: 0%;
}

.input-userprofile:hover {
  width: 100%;
}



.country-dropdown select {
  width: 80px;
  height: 40px;
  border: 2px solid red;
  border-right: none;
  /* margin: 10px; */
}

.mobile-input {
  flex: 1;

}

.mobile-input input {
  height: 40px;
  border: 2px solid red;
  /* border-left: none; */
  padding: 0%;
  margin-top: 3%;
}

.account-details {
  margin-top: 3%;
}

.input-organization {
  display: flex;
  justify-content: left;
}

.passwordfield {
  margin-top: 2%;
  border: 2px solid #378CEF;

}

.passwordfield>input {
  height: 40px;
  padding: 0px;
  background-color: white;
}

.passwordbtn {
  margin-top: 5%;

}

.passwordbtn>button {
  width: 100%;
  height: 40px;
  background-color: #378CEF;
  /* border: 2px solid rgb(246,234,227); */
  font-size: large;
  font-weight: bold;
  color: white;
  border: none;
  cursor: pointer;

}

/* .custom-input{
  
 border: 1px solid #FF8C78;
 border-radius: 3px;
} */
.latoBold {
  font-weight: 700;
}

.forgot-password input {
  width: 100%;
  height: 36px;
  border-radius: 4px;
  outline: none
}

.forgot-password .email {
  border: 1.5px solid #d0d0d0;
  padding-left: 10px;
  border-bottom: 1px solid #ccc !important;
}

.forgot-password .submit {
  background-color: #378CEF;
  border: none;
  color: white;
  cursor: pointer;

}

.forgot-password .submit:hover {
  background-color: #073a70;

}

.enter-password input {
  width: 100%;
  height: 36px;
  border-radius: 4px;
  outline: none;
  border: 1.5px solid #d0d0d0;
  padding-left: 10px;

}


.enter-password .submit {
  background-color: #378CEF;
  border: none;
  color: white;
  cursor: pointer;

}

.enter-password .submit:hover {
  background-color: #073a70;

}

.error-message {
  text-align: center;
  color: red;
}

.signupError {
  margin-top: 20px;
  text-align: center;
  color: red;
}

.visibility {
  display: flex;
  justify-content: space-between;

}</style>